import template from './product.html';
import controller from './product.controller';
import './product.scss';

let productComponent = {
  bindings: {},
  template,
  controller
};

export default productComponent;



// WEBPACK FOOTER //
// ./client/app/components/product/product.component.js